import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M17.54 0H6.46a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h11.08a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3m1 21a1 1 0 0 1-1 1H6.46a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1.31l.11.34A2.08 2.08 0 0 0 9.9 4h4.2a2.08 2.08 0 0 0 2-1.66l.13-.34h1.31a1 1 0 0 1 1 1Z"
    }, null, -1)
  ]));
}
const computerDeviceMobilePhoneIphoneX = { render };
export {
  computerDeviceMobilePhoneIphoneX as default,
  render
};
//# sourceMappingURL=computer-device-mobile-phone-iphone-x.svg.js.map
